import {
  FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID,
  FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_SUCCESS,
  FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_FAILURE,
} from "./actionTypes";

export const fetchTosByJobIdAndCandidateId = (request) => ({
  type: FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID,
  payload: request,
});

export const fetchTosByJobIdAndCandidateIdSuccess = (payload) => ({
  type: FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_SUCCESS,
  payload: payload,
});

export const fetchTosByJobIdAndCandidateIdFailure = (error) => ({
  type: FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_FAILURE,
  payload: error,
});
